import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 合同类型
 */
class StockContractType extends UltMeta {
    WAREHOUSING = new Meta(11, "仓储合同");
}

export const STOCK_CONTRACT_TYPE = new StockContractType();

/**
 * 收费项
 */
class FeeItem extends UltMeta {
    STOCK = new Meta(1, "仓储费");
    TRANSFER = new Meta(2, "过户费");
    INBOUND = new Meta(3, "入库费");
    OUTBOUND = new Meta(4, "出库费");
}

export const FEE_ITEM = new FeeItem();
